import {
  isBenignAuthSignOutError,
  signOutClientSession,
} from './authSignOut';
import {
  clearAcademySignupBooking,
  clearCommunitySignupBooking,
  clearDraft,
  readDraft,
  writeDraft,
  writeSignupCommunityLogoDataUrl,
} from '../components/signup/signupState';

export const SIGNUP_SKIP_AUTO_REDIRECT_KEY = 'signup_skip_auto_redirect';

export function clearSignupSkipAutoRedirect() {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(SIGNUP_SKIP_AUTO_REDIRECT_KEY);
  } catch {
    /* ignore */
  }
}

/** End the signup OAuth session and clear signup-flow session flags. */
export async function signOutSignupFlow() {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(SIGNUP_SKIP_AUTO_REDIRECT_KEY, '1');
    sessionStorage.removeItem('academy_signup_flow');
    sessionStorage.removeItem('community_signup_flow');
  }
  clearAcademySignupBooking();
  clearCommunitySignupBooking();

  try {
    await signOutClientSession();
  } catch (error) {
    if (!isBenignAuthSignOutError(error)) {
      clearSignupSkipAutoRedirect();
      throw error;
    }
  }
}

/**
 * Sign out and reset intake draft so "Signed in as …" / SSO identity
 * does not linger after Back or Switch account from /signup/community.
 * Keeps persona so /signup/account still shows the correct headline.
 */
export async function signOutSignupIntake({ preservePersona = true } = {}) {
  const persona = preservePersona ? readDraft()?.persona : null;

  try {
    await signOutSignupFlow();
  } catch (error) {
    if (!isBenignAuthSignOutError(error)) {
      throw error;
    }
  }

  clearDraft();
  writeSignupCommunityLogoDataUrl('');

  if (persona) {
    writeDraft({ persona, signupStep: 1 });
  }
}
